import { Translation } from '@ps/web-shared-components';
import type { ChangeEvent } from 'react';
import React, { useContext } from 'react';
import { useRouteMatch } from 'react-router';

import { Checkbox } from '@swf/poker';

import ClubContext from '../../ClubContext/ClubContext';
import useUpdateIgnoreClubEmailsFlag from '../hooks/useUpdateIgnoreClubEmailsFlag';
import { row } from '../shared.scss';

import { TXTCLI_I_do_not_wish_to_receive_e_mai_ELL } from './EmailNotifications.messages.json';

const EmailNotifications: React.FC = () => {
  const {
    state: {
      settings: { blockClubMail }
    }
  } = useContext(ClubContext);
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const { handleSetEmailFlag, loading } = useUpdateIgnoreClubEmailsFlag();
  const handleChange = (_: ChangeEvent<object>, checked: boolean) => {
    handleSetEmailFlag(checked, Number(clubId));
  };

  return (
    <div className={row}>
      <Checkbox
        onChange={handleChange}
        disabled={loading}
        value="end"
        checked={blockClubMail}
        label={<Translation {...TXTCLI_I_do_not_wish_to_receive_e_mai_ELL} />}
      />
    </div>
  );
};

export default EmailNotifications;
